import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
@Component({
  standalone: true,
  imports: [CommonModule],
  selector: 'app-disclaimer-banner',
  templateUrl: './disclaimer-banner.component.html',
  styleUrls: ['./disclaimer-banner.component.scss']
})
export class DisclaimerBannerComponent {
  constructor(private router: Router) {}

  onBannerClick(): void {
    this.router.navigate(['/disclaimer']);
  }
} 